module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("微信 Vue 单页面应用设置标题")]), _vm._v(" "), _c('p', [_vm._v("在微信"), _c('code', [_vm._v("iOS")]), _vm._v(" "), _c('code', [_vm._v("webview")]), _vm._v("更新到"), _c('code', [_vm._v("WKWebView")]), _vm._v("之前我们可以通过加载一个 "), _c('code', [_vm._v("iframe")]), _vm._v(" 来实现单页面应用"), _c('code', [_vm._v("title")]), _vm._v("更改。但是17年初更新到 "), _c('code', [_vm._v("WKWebView")]), _vm._v(" 后该方法也失效。")]), _vm._v(" "), _c('p', [_vm._v("目前该问题已经解决，在微信 iOS 客户端 "), _c('code', [_vm._v("6.3.5")]), _vm._v(" 之后的版本都可以通过 "), _c('code', [_vm._v("document.title")]), _vm._v(" 设置标题了。")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-36d11ede", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-36d11ede"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/wechat-document-title-191.vue
// module id = 2148
// module chunks = 191